import React from "react";
import ArchitectureDiagram from "../../../../assets/images/cloudPlus/architecture-diagram.svg";
import Icon1 from "../../../../assets/images/trueCloud/1.svg";
import Icon3 from "../../../../assets/images/trueCloud/3.svg";
import Icon2 from "../../../../assets/images/trueCloud/2.svg";
import Icon8 from "../../../../assets/images/trueCloud/8.svg";
import Icon12 from "../../../../assets/images/trueCloud/12.svg";
import Icon10 from "../../../../assets/images/trueCloud/10.svg";

const ServicePill = ({ icon, label }) => (
  <div className="flex items-center gap-2 bg-[#F9FBFF] border border-white rounded-[10px] px-1.5 h-8 shrink-0">
    <span className="w-6 h-6 flex items-center justify-center shrink-0">
      <img src={icon} alt="" className="w-[18px] h-[18px] bg-[#F9FBFF]" />    </span>
    <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal whitespace-nowrap">
      {label}
    </p>
  </div>
);

const cloudServices = [
  { icon: Icon1, label: "User Interface" },
  { icon: Icon10, label: "Web RTC / video interconnect" },
  { icon: Icon3, label: "Updates" },
  { icon: Icon2, label: "Stored backups" },
  { icon: Icon8, label: "Push notifications" },
  { icon: Icon12, label: "Mobile application" },
];

export const CloudPlusOverviewSection = () => {
  return (
    <section className="bg-white px-6 lg:px-[120px] py-[60px]">
      <div className="max-w-[1260px] mx-auto flex flex-col items-center gap-8">


        <div className="w-full overflow-x-auto">
          <img
            src={ArchitectureDiagram}
            alt="RMC Plus system architecture diagram"
            className="w-full  h-auto object-contain mx-auto"
          />
        </div>
      </div>
    </section>
  );
};
